import { render } from "./ProjectsCreateModalDatasets.vue?vue&type=template&id=17c23d10"
import script from "./ProjectsCreateModalDatasets.vue?vue&type=script&lang=js"
export * from "./ProjectsCreateModalDatasets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__